module.exports = __webpack_public_path__ + "i18n/es.fa26497c8527fb8654d90e75c2c26a7a.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 1854
// module chunks = 0